














































import { Component, Vue } from 'vue-property-decorator'
import { hls, Load } from '@/units'
import { lowerCase } from '@/utils'

@Component
export default class Views extends Vue {
  // __DATA
  private search: string = ''
  private active: any = null
  
  // __CREATED
  public async created () {
    Load(this, true)

    await this.$store.dispatch('APP.USERS/callVie')
    this.$store.dispatch('APP.USERS/callPer')
    this.$store.dispatch('APP.COG/addOn', { path: '/camera', state: 'cameras' })

    Load(this, false)
  }

  // __METHODS
  private edit (data: any): void {
    this.$emit('events', { type: 'edit', data })
  }

  private remove (data: any): void {
    const conf: boolean = confirm(`Disabled [${data.name}]?`)
    if (conf) {
      this.$emit('events', { type: 'remove', data })
    }
  }

  private h (val: string): string {
    return hls(val, this.search)
  }

  // __COMPUTED
  private get store (): any {
    const search: string = lowerCase(this.search)
    let views: any = this.$store.getters['APP.USERS/views']

    if (this.search) {
      views = views.filter((x: any) => lowerCase(x.name).includes(search))
    }

    if (this.active !== null) {
      views = views.keep('isActive', this.active)
    }

    return views
  }

  private get db (): any {
    return {
      active: [
        { id: 1, name: this.$t('enabled') },
        { id: 0, name: this.$t('disabled') }
      ]
    }
  }
}
